<template>
  <div style="color:white;" >
    <v-container class="my-14">



      <v-card class="pt-5" style="max-width:600px; margin: auto;">
        <v-card-title>
          <h2 class="mtfont">Reset Password</h2>
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-text-field
              type="email"
              label="*Email"
              v-model="username"
            />
            <v-text-field
              type="Password"
              label="*Password"
              v-model="password"
            />
            <v-text-field
              type="Password"
              label="*Verify Password"
              v-model="rePassword"
            />
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn text color="black" class="mtfont" v-on:click="$router.push({name: 'Login'})">Login</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            color="black"
            style="color: #fecb39;"
            class="mtfont"
            v-on:click="attemptReset"
          >Reset</v-btn>
        </v-card-actions>
      </v-card>



    </v-container>
  </div>
</template>

<script>

export default {
  name: 'Register',
  data: () => ({
    username: '',
    password: '',
    rePassword: ''
  }),
  methods: {
    attemptReset(event) {
      if(!this.password || !this.rePassword || !this.username) return alert('All Fields Must be Filled In');
      if(this.password !== this.rePassword) return alert('Passwords Must Match');

      this.$store.dispatch('resetPassword',{
        "username": this.username,
        "password": this.password,
        "token": this.$route.query.rst
      }).then(response => {
        if(response === "SUCCESS") this.$router.push({name: 'Login'});
        else alert('Invalid Username!');
      });
    }
  }
}
</script>

<style scoped>

</style>